export const members = {
  title: 'Members',
  subtitle: (org: string) => `People in ${org} who can use Queri.`,
  seats: (used: number, limit: number) => `${used} of ${limit} seats used`,
  seatsUnlimited: (used: number) => `${used} members and pending invitations`,
  inviteLabel: 'Invite by email',
  invitePlaceholder: 'name@company.com',
  invite: 'Invite',
  inviting: 'Sending…',
  invited: (email: string) => `Invitation sent to ${email}`,
  inviteFailed: 'Could not send the invitation',
  inviteHint: 'They get an email with their own link to join.',
  people: 'People',
  name: 'Name',
  role: 'Role',
  status: 'Status',
  joined: 'Joined',
  admin: 'Admin',
  member: 'Member',
  you: 'you',
  active: 'Active',
  invitedStatus: 'Not signed in yet',
  makeAdmin: 'Make admin',
  makeMember: 'Make member',
  remove: 'Remove',
  removeTitle: 'Remove member',
  removeDescription: (name: string) =>
    `${name} will no longer be able to sign in. Their projects and playbooks move to you.`,
  cancel: 'Cancel',
  removed: 'Member removed',
  roleChanged: 'Role updated',
  actionFailed: 'Something went wrong',
  pending: 'Pending invitations',
  sent: 'Sent',
  expires: 'Expires',
  expired: 'Expired',
  resend: 'Resend',
  revoke: 'Revoke',
  resent: 'Invitation sent again',
  revoked: 'Invitation revoked',
  noAccess: 'Only admins can manage members. Ask an admin in your organization.',
};

export type MembersDict = typeof members;
